(function () {
'use strict';

var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	};

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

	}

})(jQuery);

var documentInit$1 = documentInit;

var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();
			console.log(this);

		}
		init() {
			this.$trigger = $(selectors.trigger, this.$container);
			this.$links = $('a', this.$container).not(this.$trigger);
		}

		bind() {
			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

	}

})(jQuery);


var mobileNavInit$1 = mobileNavInit;

var searchFormInit;

(function ($) {

	const selectors = {
		form: '[data-search-form]',
		datepicker: '[data-toggle="datepicker"]',
		progressBar: '[data-progress-bar]',
		progressBarProgress: '[data-progress-bar-progress]',
		progressBarLabel: '[data-progress-bar-label]',
	};

	searchFormInit = function () {
		$(selectors.form).each((i, el) => {
			new SearchForm(el);
		});
	};

	class SearchForm {
		constructor(element) {

			this.$form = $(element);

			if (this.$form.length) {
				this.init();
			}

		}
		init() {

			this.bind();

			$(selectors.datepicker, this.$form).datepicker({
				language: 'pl-PL',
				format: 'yyyy-mm-dd',
				autoHide: true
			});

		}

		bind() {
			this.onSubmit = this.onSubmit.bind(this);
			this.$form.on('submit', this.onSubmit);
		}

		onSubmit(e) {

			const self = this;

			e.preventDefault();

			var raw_data = this.$form.serializeArray();
			var data = {};
			$.each(raw_data, (i, el) => {
				data[el.name] = el.value;
			});

			if (!data.db) return false;

			self.search(data);

		}

		search(data) {

			const self = this;
			var i = 0;

			var num_results = 0;
			var total_results = -1;
			var results_in_db = 0;

			data.search_id = this.generateId();

			console.log(data);

			$(selectors.progressBar, self.$form).show();
			$(selectors.progressBar, self.$form).find(selectors.progressBarProgress).css('width', '0%');
			$(selectors.progressBar, self.$form).find(selectors.progressBarLabel).text('0%');

			$('[type="submit"]', self.$form).addClass('is-loading');

			function do_search_ceidg(data) {

				var start_time = Date.now();

				$.ajax({
					type: "POST",
					url: wp_params.ajax_url,
					data: {
						'action': 'search_db',
						'args': data
					},
					success: response => {

						if (!response.success) return;

						if (response.total) {
							total_results = response.total;
							num_results += response.found;
							var perc = (100 * num_results / total_results);
							perc = Math.round((perc + Number.EPSILON) * 100) / 100;

							$(selectors.progressBar, self.$form).find(selectors.progressBarProgress).css('width', perc + '%');
							$(selectors.progressBar, self.$form).find(selectors.progressBarLabel).text(perc + '%');
						}

						if (response.in_db) results_in_db += response.in_db;

						if (response.next) {

							var next_time = start_time + 26 * 3600;
							var delay = (next_time - Date.now());

							if (delay < 0) delay = 0;
							delay += 10;

							setTimeout(_ => {

								data.url = response.next;
								do_search_ceidg(data);
							}, delay);
						}
						else {

							$(selectors.progressBar, self.$form).hide();
							if (response.result_file) {
								var new_url = window.location.origin + window.location.pathname + '?file=' + response.result_file;
								if (results_in_db) new_url += '&found=' + results_in_db;

								window.location.href = new_url;
							}

						}

					}
				});

			}

			function do_search_krs(data) {
				i++;

				data.page = i;

				$.ajax({
					type: "POST",
					url: wp_params.ajax_url,
					data: {
						'action': 'search_db',
						'args': data
					},
					success: response => {

						if (!response.success) return;

						if (response.total) {
							total_results = response.total;
							num_results += response.found;
							var perc = (100 * num_results / total_results);
							perc = Math.round((perc + Number.EPSILON) * 100) / 100;

							$(selectors.progressBar, self.$form).find(selectors.progressBarProgress).css('width', perc + '%');
							$(selectors.progressBar, self.$form).find(selectors.progressBarLabel).text(perc + '%');
						}

						if (response.in_db) results_in_db += response.in_db;

						if (num_results < total_results) {
							do_search_krs(data);
						}
						else {

							$(selectors.progressBar, self.$form).hide();
							if (response.result_file) {
								var new_url = window.location.origin + window.location.pathname + '?file=' + response.result_file;
								if (results_in_db) new_url += '&found=' + results_in_db;

								window.location.href = new_url;
							}

						}

					}
				});

			}

			switch (data.db) {
				case 'ceidg':
					do_search_ceidg(data);
					break;
				case 'krs':
					do_search_krs(data);
					break;
			}



		}

		generateId(prefix = "", random = false) {
			const sec = Date.now() * 1000 + Math.random() * 1000;
			const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
			return `${prefix}${id}${random ? `.${Math.trunc(Math.random() * 100000000)}` : ""}`;
		}

	}

})(jQuery);

var searchFormInit$1 = searchFormInit;

(function ($) {

	$(document).ready(function () {

		documentInit$1();
		mobileNavInit$1();
		searchFormInit$1();

	});

})(jQuery);

}());
